import { render, staticRenderFns } from "./TeacherProfileMini.vue?vue&type=template&id=f5f011f6&scoped=true&"
import script from "./TeacherProfileMini.vue?vue&type=script&lang=js&"
export * from "./TeacherProfileMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f011f6",
  null
  
)

export default component.exports